if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.submitButton = this.querySelector('[type="submit"]');
        this.cart = document.querySelector("cart-drawer");
        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.form.dataset.variantLoading === "true") return;
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;
        this.handleErrorMessage();

        /* Clamp quantity to max before submitting */
        const qtyInput = this.form.querySelector('input[name="quantity"]');
        if (qtyInput) {
          const max = parseInt(qtyInput.getAttribute("max"), 10);
          const min = parseInt(qtyInput.getAttribute("min"), 10) || 1;
          let val = parseInt(qtyInput.value, 10);
          if (isNaN(val) || val < min) val = min;
          else if (!isNaN(max) && val > max) val = max;
          qtyInput.value = val;
        }

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".spinner-loading-btn")?.classList.remove("hidden");
        this.submitButton
          .querySelector("[data-addtocart-text]")
          .classList.add("hidden");
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append("sections_url", window.location.pathname);
        }
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.submitButton.setAttribute("aria-disabled", true);
              this.error = true;
              fetch(
                `${routes.cart_url}?sections=` +
                  this.cart
                    .getSectionsToRender()
                    .map((section) => section.id)
                    .toString(),
              )
                .then((response) => response.json())
                .then((response) => {
                  let parsedState = {};
                  parsedState["sections"] = response;
                  this.cart.renderContents(parsedState);
                });
              this.resetButton();
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            this.error = false;
            if (this.cart) {
              if (document.querySelector(".product-cart-sticky")) {
                document
                  .querySelector(".product-cart-sticky")
                  .classList.remove("active");
                document
                  .querySelector(
                    ".product-cart-sticky .product-cart-sticky-detail",
                  )
                  .classList.remove("active");
              }
              this.cart.renderContents(response);
              this.cart.classList.add("open");
              document.querySelector("body").classList.add("no-scroll");
            }
            /* Fetch cart state, update max, then re-enable button */
            return fetch(window.routes.cart_url + ".js")
              .then(function (r) {
                return r.json();
              })
              .then((cartData) => {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  cartState: cartData,
                });
                this.resetButton();
              })
              .catch(() => {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                });
                this.resetButton();
              });
          })
          .catch((e) => {
            console.error(e);
            this.resetButton();
          });
      }

      resetButton() {
        this.submitButton.classList.remove("loading");
        this.submitButton
          .querySelector("[data-addtocart-text]")
          .classList.remove("hidden");
        if (this.cart && this.cart.classList.contains("is-empty"))
          this.cart.classList.remove("is-empty");
        this.submitButton.removeAttribute("aria-disabled");
        this.querySelector(".spinner-loading-btn")?.classList.add("hidden");
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );
        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}
